module.exports = __webpack_public_path__ + "static/media/latLong.eb755df3.png";